import React, { useState } from 'react';
import { useParamsLegacy as useParams } from '@leagueplatform/routing';
import { useIntl } from '@leagueplatform/locales';
import { CHALLENGE_STATUS } from '#constants/challenges.constants.tsx';
import { SettingsCog } from '#components/settings-cog/settings-cog.component.tsx';
import { SettingsDropdownItem } from '#components/settings-dropdown/settings-dropdown-item.component.tsx';
import { track } from '@leagueplatform/analytics';
import { CHALLENGE_CAMPAIGN_TYPE } from '#constants/analytics.constants.tsx';
import { JOURNEY_ROUTES } from '@leagueplatform/health-journey-common';
import { LeaveChallengeModal } from '../leave-challenge-modal/leave-challenge-modal.component';

export interface HeadingSettingsCogProps {
  status: string;
  isSoloChallenge: boolean;
  title: string;
}

export const HeadingSettingsCog = ({
  status,
  isSoloChallenge,
  title,
}: HeadingSettingsCogProps) => {
  const { challengeId } = useParams<{ challengeId: string }>();
  const { formatMessage } = useIntl();
  const [displayLeaveChallengeModal, setDisplayLeaveChallengeModal] =
    useState(false);
  const [isSettingsDropdownOpen, setIsSettingsDropdownOpen] = useState(false);

  const isChallengeLeavable =
    status === CHALLENGE_STATUS.UPCOMING || status === CHALLENGE_STATUS.ACTIVE;

  return (
    <SettingsCog
      modalIsOpen={displayLeaveChallengeModal}
      isSettingsDropdownOpen={isSettingsDropdownOpen}
      setIsSettingsDropdownOpen={setIsSettingsDropdownOpen}
    >
      {!isSoloChallenge && (
        <SettingsDropdownItem
          to={JOURNEY_ROUTES.getChallengeSettings(challengeId)}
        >
          {formatMessage({ id: 'PRIVACY' })}
        </SettingsDropdownItem>
      )}
      {isChallengeLeavable && (
        <>
          <SettingsDropdownItem
            onClick={() => {
              setDisplayLeaveChallengeModal(true);
              track(
                'challenges.button_clicked.challenges_settings_modal.leave_challenge',
                {
                  health_campaign_id: challengeId ?? '',
                  health_campaign_name: title,
                  health_campaign_type: CHALLENGE_CAMPAIGN_TYPE,
                  challenge_status: status,
                },
              );
            }}
          >
            {formatMessage({ id: 'LEAVE_CHALLENGE' })}
          </SettingsDropdownItem>
          <LeaveChallengeModal
            isSettingsDropdownOpen={displayLeaveChallengeModal}
            onDismiss={() => {
              setDisplayLeaveChallengeModal(false);
            }}
            title={title}
          />
        </>
      )}
    </SettingsCog>
  );
};
